document.addEventListener('DOMContentLoaded', function () {
  const loadMoreButton = document.querySelector('.load-more-button');
  if (!loadMoreButton) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          loadMore(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '200px',
      threshold: 0
    }
  );

  observer.observe(loadMoreButton);

  function loadMore(button) {
    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl) return;

    button.disabled = true;
    button.textContent = 'Loading…';

    fetch(nextUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newItems = doc.querySelectorAll('#product-grid > li');
        const grid = document.querySelector('#product-grid');

        newItems.forEach(item => grid.appendChild(item));

        const nextButton = doc.querySelector('.load-more-button');

        if (nextButton) {
          button.dataset.nextUrl = nextButton.dataset.nextUrl;
          button.disabled = false;
          button.textContent = 'Loading…';

          observer.observe(button);
        } else {
          button.remove();
        }
      })
      .catch(() => {
        button.textContent = 'Error. Try again';
        button.disabled = false;
      });
  }
});
